
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "convex/react";
import { api } from "./convex/_generated/api";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

import "./MentalEmotionalPage.css";

export default function MentalEmotionalPage() {
  const { progressId, userId } = useParams();

   

  const [meditationMinutes, setMeditationMinutes] =
    useState("");

  const [journalingMinutes, setJournalingMinutes] =
    useState("");

  const [readingMinutes, setReadingMinutes] =
    useState("");

  const [mindfulnessMinutes, setMindfulnessMinutes] =
    useState("");

  const [mood, setMood] = useState(5);

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const calculateMentalEmotional = useMutation(
    api.progress.calculateMentalEmotional
  );

  const usualresult = useQuery(
    api.progress.getMentalEmotionalResults,
    progressId && userId
      ? {
          userId,
          progressId,
        }
      : "skip"
  );

  console.log(
    "MENTAL EMOTIONAL USUAL RESULT:",
    usualresult
  );

  const dailyRecords =
    usualresult?.dailyRecords ?? [];

  const weeklyRecords =
    usualresult?.weeklyRecords ?? [];

  const sortedDailyRecords = [
    ...dailyRecords,
  ].sort((a, b) =>
    a.date.localeCompare(b.date)
  );

  const sortedWeeklyRecords = [
    ...weeklyRecords,
  ].sort((a, b) =>
    a.weekStart.localeCompare(b.weekStart)
  );

  const latestWeeklyRecord =
    sortedWeeklyRecords.length > 0
      ? sortedWeeklyRecords[
          sortedWeeklyRecords.length - 1
        ]
      : null;

  const dailyScoreChartData =
    sortedDailyRecords.map((record) => ({
      date: record.date,

      dailyScore: Math.round(
        Number(record.dailyScore ?? 0)
      ),
    }));

  console.log(
    "MENTAL DAILY RECORDS:",
    dailyRecords
  );

  console.log(
    "MENTAL DAILY CHART DATA:",
    dailyScoreChartData
  );

  const weeklyScoreChartData =
    sortedWeeklyRecords.map((record) => ({
      week: record.weekStart,

      trackingScore: Math.round(
        Number(record.weeklyScore ?? 0)
      ),

      activityScore: Math.round(
        Number(record.activityScore ?? 0)
      ),

      finalScore: Math.round(
        Number(record.finalScore ?? 0)
      ),
    }));

  console.log(
    "MENTAL WEEKLY RECORDS:",
    weeklyRecords
  );

  console.log(
    "MENTAL WEEKLY CHART DATA:",
    weeklyScoreChartData
  );

  const activityChartData =
    latestWeeklyRecord
      ? [
          {
            name: "Meditation",
            minutes: Number(
              latestWeeklyRecord
                .totalMeditationMinutes ?? 0
            ),
          },

          {
            name: "Journaling",
            minutes: Number(
              latestWeeklyRecord
                .totalJournalingMinutes ?? 0
            ),
          },

          {
            name: "Reading",
            minutes: Number(
              latestWeeklyRecord
                .totalReadingMinutes ?? 0
            ),
          },

          {
            name: "Mindfulness",
            minutes: Number(
              latestWeeklyRecord
                .totalMindfulnessMinutes ?? 0
            ),
          },
        ]
      : [];

  const getCurrentWeek = () => {
    const today = new Date();

    const day = today.getDay();

    const daysSinceMonday =
      day === 0 ? 6 : day - 1;

    const monday = new Date(today);

    monday.setDate(
      today.getDate() - daysSinceMonday
    );

    const sunday = new Date(monday);

    sunday.setDate(
      monday.getDate() + 6
    );

    const weekStart = monday
      .toISOString()
      .split("T")[0];

    const weekEnd = sunday
      .toISOString()
      .split("T")[0];

    return {
      weekStart,
      weekEnd,
    };
  };

  const getToday = () => {
    const today = new Date();

    return today
      .toISOString()
      .split("T")[0];
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setResult(null);

    try {
      setLoading(true);

      const meditation =
        Number(meditationMinutes);

      const journaling =
        Number(journalingMinutes);

      const reading =
        Number(readingMinutes);

      const mindfulness =
        Number(mindfulnessMinutes);

      const moodValue =
        Number(mood);

      if (
        Number.isNaN(meditation) ||
        Number.isNaN(journaling) ||
        Number.isNaN(reading) ||
        Number.isNaN(mindfulness) ||
        Number.isNaN(moodValue)
      ) {
        setError(
          "Please enter valid numbers."
        );
        return;
      }

      if (
        meditation < 0 ||
        journaling < 0 ||
        reading < 0 ||
        mindfulness < 0
      ) {
        setError(
          "Minutes cannot be negative."
        );
        return;
      }

      if (
        moodValue < 1 ||
        moodValue > 10
      ) {
        setError(
          "Mood must be between 1 and 10."
        );
        return;
      }

      const date = getToday();

      const {
        weekStart,
        weekEnd,
      } = getCurrentWeek();

      const response =
        await calculateMentalEmotional({
          userId,
          progressId,

          date,

          meditationMinutes:
            meditation,

          journalingMinutes:
            journaling,

          readingMinutes:
            reading,

          mindfulnessMinutes:
            mindfulness,

          mood: moodValue,

          weekStart,
          weekEnd,
        });

      console.log(
        "Mental & Emotional Result:",
        response
      );

      setResult({
        ...response,
        date,
      });
    } catch (err) {
      console.error(
        "Mental & Emotional Error:",
        err
      );

      setError(
        err?.message ||
          "Failed to save mental and emotional data."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mental-emotional-page">
      <div className="mental-emotional-container">

        {/* PAGE TITLE */}

        <div className="mental-emotional-header">
          <h1>
            Mental & Emotional
          </h1>

          <p>
            Track your mental and emotional
            wellbeing and see how your habits
            contribute to your weekly score.
          </p>
        </div>

        {/* DAILY INPUT */}

        <form
          onSubmit={handleSubmit}
          className="mental-emotional-form"
        >

          {/* Meditation */}

          <div className="mental-input-group">
            <label>
              Meditation minutes today
            </label>

            <input
              type="number"
              min="0"
              value={meditationMinutes}
              onChange={(e) =>
                setMeditationMinutes(
                  e.target.value
                )
              }
              placeholder="Example: 15"
            />
          </div>

          {/* Journaling */}

          <div className="mental-input-group">
            <label>
              Journaling minutes today
            </label>

            <input
              type="number"
              min="0"
              value={journalingMinutes}
              onChange={(e) =>
                setJournalingMinutes(
                  e.target.value
                )
              }
              placeholder="Example: 10"
            />
          </div>

          {/* Reading */}

          <div className="mental-input-group">
            <label>
              Reading minutes today
            </label>

            <input
              type="number"
              min="0"
              value={readingMinutes}
              onChange={(e) =>
                setReadingMinutes(
                  e.target.value
                )
              }
              placeholder="Example: 20"
            />
          </div>

          {/* Mindfulness */}

          <div className="mental-input-group">
            <label>
              Mindfulness minutes today
            </label>

            <input
              type="number"
              min="0"
              value={mindfulnessMinutes}
              onChange={(e) =>
                setMindfulnessMinutes(
                  e.target.value
                )
              }
              placeholder="Example: 10"
            />
          </div>

          {/* Mood */}

          <div className="mental-mood-group">
            <div className="mood-label-row">
              <label>
                How are you feeling today?
              </label>

              <span className="mood-value">
                {mood}/10
              </span>
            </div>

            <input
              type="range"
              min="1"
              max="10"
              value={mood}
              onChange={(e) =>
                setMood(
                  Number(e.target.value)
                )
              }
            />

            <div className="mood-scale">
              <span>1</span>
              <span>10</span>
            </div>
          </div>

          {/* Submit */}

          <button
            type="submit"
            disabled={loading}
            className="mental-submit"
          >
            {loading
              ? "Saving..."
              : "Save Mental & Emotional"}
          </button>

        </form>

        {/* ERROR */}

        {error && (
          <p className="mental-error">
            {error}
          </p>
        )}

        {/* STORED RESULT COUNTS */}

        <div className="mental-record-counts">

          <div className="record-count">
            <span>Daily records</span>
            <strong>
              {dailyRecords.length}
            </strong>
          </div>

          <div className="record-count">
            <span>Weekly records</span>
            <strong>
              {weeklyRecords.length}
            </strong>
          </div>

        </div>

        {/* IMMEDIATE RESULT */}

        {result && (
          <div className="mental-results">

            {/* TODAY'S SCORE */}

            <div className="mental-card today-score-card">

              <div className="score-card-heading">
                <div>
                  <p className="score-eyebrow">
                    Daily Wellness
                  </p>

                  <h2>
                    Today's Mental & Emotional Score
                  </h2>
                </div>

                <span className="score-badge">
                  /100
                </span>
              </div>

              <p className="today-score-value">
                {Math.round(
                  Number(
                    result.dailyScore ?? 0
                  )
                )}
              </p>

              <p className="score-date">
                {result.date}
              </p>

            </div>

            {/* CURRENT WEEK SCORE CARDS */}

            <div className="weekly-score-section">

              <div className="section-heading">
                <p className="score-eyebrow">
                  Current Week
                </p>

                <h2>
                  Weekly Mental & Emotional Score
                </h2>
              </div>

              <div className="weekly-score-grid">

                {/* Tracking */}

                <div className="score-card tracking-card">

                  <p className="score-label">
                    Tracking Score
                  </p>

                  <p className="score-value">
                    {Math.round(
                      Number(
                        result.trackingScore ?? 0
                      )
                    )}
                  </p>

                  <span className="score-line" />

                </div>

                {/* Activity */}

                <div className="score-card activity-card">

                  <p className="score-label">
                    Activity Score
                  </p>

                  <p className="score-value">
                    {Math.round(
                      Number(
                        result.activityScore ?? 0
                      )
                    )}
                  </p>

                  <span className="score-line" />

                </div>

                {/* Final */}

                <div className="score-card final-card">

                  <p className="score-label">
                    Final Score
                  </p>

                  <p className="score-value">
                    {Math.round(
                      Number(
                        result.finalScore ?? 0
                      )
                    )}
                  </p>

                  <span className="score-line" />

                </div>

              </div>
            </div>

          </div>
        )}

        {/* DAILY STORED RESULTS */}

        {dailyScoreChartData.length > 0 && (
          <div className="mental-card chart-card">

            <div className="chart-heading">
              <div>
                <p className="score-eyebrow">
                  History
                </p>

                <h2>
                  Daily Mental & Emotional Scores
                </h2>
              </div>

              <span className="chart-badge">
                Daily
              </span>
            </div>

            <div className="chart-container">
              <ResponsiveContainer
                width="100%"
                height="100%"
              >
                <BarChart
                  data={dailyScoreChartData}
                >
                  <CartesianGrid
                    strokeDasharray="3 3"
                    stroke="#26372d"
                  />

                  <XAxis
                    dataKey="date"
                    stroke="#94a3b8"
                    tick={{
                      fill: "#94a3b8",
                      fontSize: 12,
                    }}
                    axisLine={{
                      stroke: "#26372d",
                    }}
                    tickLine={false}
                  />

                  <YAxis
                    domain={[0, 100]}
                    stroke="#94a3b8"
                    tick={{
                      fill: "#94a3b8",
                      fontSize: 12,
                    }}
                    axisLine={false}
                    tickLine={false}
                  />

                  <Tooltip
                    contentStyle={{
                      background: "#07100a",
                      border:
                        "1px solid rgba(74, 222, 128, 0.25)",
                      borderRadius: "12px",
                      color: "#f8fafc",
                    }}
                  />

                  <Legend />

                  <Bar
                    dataKey="dailyScore"
                    name="Daily Score"
                    fill="#4ade80"
                    radius={[
                      7,
                      7,
                      0,
                      0,
                    ]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>

          </div>
        )}

        {/* WEEKLY STORED RESULTS */}

        {weeklyScoreChartData.length > 0 && (
          <div className="mental-card chart-card">

            <div className="chart-heading">
              <div>
                <p className="score-eyebrow">
                  History
                </p>

                <h2>
                  Weekly Mental & Emotional Scores
                </h2>
              </div>

              <span className="chart-badge">
                Weekly
              </span>
            </div>

            <div className="chart-container">
              <ResponsiveContainer
                width="100%"
                height="100%"
              >
                <BarChart
                  data={weeklyScoreChartData}
                >
                  <CartesianGrid
                    strokeDasharray="3 3"
                    stroke="#26372d"
                  />

                  <XAxis
                    dataKey="week"
                    stroke="#94a3b8"
                    tick={{
                      fill: "#94a3b8",
                      fontSize: 12,
                    }}
                    axisLine={{
                      stroke: "#26372d",
                    }}
                    tickLine={false}
                  />

                  <YAxis
                    domain={[0, 100]}
                    stroke="#94a3b8"
                    tick={{
                      fill: "#94a3b8",
                      fontSize: 12,
                    }}
                    axisLine={false}
                    tickLine={false}
                  />

                  <Tooltip
                    contentStyle={{
                      background: "#07100a",
                      border:
                        "1px solid rgba(74, 222, 128, 0.25)",
                      borderRadius: "12px",
                      color: "#f8fafc",
                    }}
                  />

                  <Legend />

                  <Bar
                    dataKey="trackingScore"
                    name="Tracking Score"
                    fill="#22c55e"
                    radius={[
                      7,
                      7,
                      0,
                      0,
                    ]}
                  />

                  <Bar
                    dataKey="activityScore"
                    name="Activity Score"
                    fill="#84cc16"
                    radius={[
                      7,
                      7,
                      0,
                      0,
                    ]}
                  />

                  <Bar
                    dataKey="finalScore"
                    name="Final Score"
                    fill="#f59e0b"
                    radius={[
                      7,
                      7,
                      0,
                      0,
                    ]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>

          </div>
        )}

        {/* STORED WEEKLY ACTIVITY MINUTES */}

        {activityChartData.length > 0 && (
          <div className="mental-card chart-card">

            <div className="chart-heading">
              <div>
                <p className="score-eyebrow">
                  Activity
                </p>

                <h2>
                  Mental & Emotional Activities
                </h2>

                <p className="chart-description">
                  Activity totals for the latest stored week.
                </p>
              </div>

              <span className="chart-badge">
                Minutes
              </span>
            </div>

            <div className="chart-container">
              <ResponsiveContainer
                width="100%"
                height="100%"
              >
                <BarChart
                  data={activityChartData}
                >
                  <CartesianGrid
                    strokeDasharray="3 3"
                    stroke="#26372d"
                  />

                  <XAxis
                    dataKey="name"
                    stroke="#94a3b8"
                    tick={{
                      fill: "#94a3b8",
                      fontSize: 12,
                    }}
                    axisLine={{
                      stroke: "#26372d",
                    }}
                    tickLine={false}
                  />

                  <YAxis
                    stroke="#94a3b8"
                    tick={{
                      fill: "#94a3b8",
                      fontSize: 12,
                    }}
                    axisLine={false}
                    tickLine={false}
                  />

                  <Tooltip
                    contentStyle={{
                      background: "#07100a",
                      border:
                        "1px solid rgba(74, 222, 128, 0.25)",
                      borderRadius: "12px",
                      color: "#f8fafc",
                    }}
                  />

                  <Legend />

                  <Bar
                    dataKey="minutes"
                    name="Minutes"
                    fill="#4ade80"
                    radius={[
                      7,
                      7,
                      0,
                      0,
                    ]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>

          </div>
        )}

        {/* LATEST STORED WEEKLY DETAILS */}

        {latestWeeklyRecord && (
          <div className="mental-card weekly-details-card">

            <div className="chart-heading">
              <div>
                <p className="score-eyebrow">
                  Stored Data
                </p>

                <h2>
                  Latest Weekly Details
                </h2>
              </div>

              <span className="chart-badge">
                Latest
              </span>
            </div>

            <div className="details-grid">

              <div className="detail-item">
                <span>Week start</span>
                <strong>
                  {latestWeeklyRecord.weekStart}
                </strong>
              </div>

              <div className="detail-item">
                <span>Week end</span>
                <strong>
                  {latestWeeklyRecord.weekEnd}
                </strong>
              </div>

              <div className="detail-item">
                <span>Days measured</span>
                <strong>
                  {latestWeeklyRecord.daysMeasured}
                </strong>
              </div>

              <div className="detail-item">
                <span>Average mood</span>
                <strong>
                  {Number(
                    latestWeeklyRecord.averageMood ?? 0
                  ).toFixed(1)}
                  /10
                </strong>
              </div>

              <div className="detail-item">
                <span>Meditation</span>
                <strong>
                  {Number(
                    latestWeeklyRecord
                      .totalMeditationMinutes ?? 0
                  )}{" "}
                  minutes
                </strong>
              </div>

              <div className="detail-item">
                <span>Journaling</span>
                <strong>
                  {Number(
                    latestWeeklyRecord
                      .totalJournalingMinutes ?? 0
                  )}{" "}
                  minutes
                </strong>
              </div>

              <div className="detail-item">
                <span>Reading</span>
                <strong>
                  {Number(
                    latestWeeklyRecord
                      .totalReadingMinutes ?? 0
                  )}{" "}
                  minutes
                </strong>
              </div>

              <div className="detail-item">
                <span>Mindfulness</span>
                <strong>
                  {Number(
                    latestWeeklyRecord
                      .totalMindfulnessMinutes ?? 0
                  )}{" "}
                  minutes
                </strong>
              </div>

              <div className="detail-item">
                <span>
                  Mental & Emotional suggestions
                </span>

                <strong>
                  {Number(
                    latestWeeklyRecord
                      .suggestionCount ?? 0
                  )}
                </strong>
              </div>

              <div className="detail-item">
                <span>Tracking score</span>

                <strong>
                  {Math.round(
                    Number(
                      latestWeeklyRecord
                        .weeklyScore ?? 0
                    )
                  )}
                </strong>
              </div>

              <div className="detail-item">
                <span>Activity score</span>

                <strong>
                  {Math.round(
                    Number(
                      latestWeeklyRecord
                        .activityScore ?? 0
                    )
                  )}
                </strong>
              </div>

              <div className="detail-item">
                <span>Final score</span>

                <strong>
                  {Math.round(
                    Number(
                      latestWeeklyRecord
                        .finalScore ?? 0
                    )
                  )}
                </strong>
              </div>

            </div>
          </div>
        )}

      </div>
    </div>
  );
}
